import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  text-align: center;
  h1 {
    margin-bottom: 20px;
    color: black;
  }
  .ant-modal-body {
    padding: 24px 62px 40px;
  }

  .ant-upload {
    background: #ebf2fc;
    display: block;
    border-radius: 8px;
    padding-top: 10px;
    margin-top: 20px;
    padding-bottom: 20px;
    button {
      margin-top: 0;
    }
  }
  .ant-upload-list-item {
    height: auto;
  }
  .ant-upload-list-item-info {
    background: #ebf2fc;
    border-radius: 8px;
    padding: 15px 20px 13px;
  }
  .ant-upload-list-item-name {
    padding-left: 0;
    color: black;
  }
  .ant-upload-list-item-card-actions {
    opacity: 1;
  }
  .anticon-paper-clip,
  .anticon-loading {
    display: none;
  }
  .anticon-delete {
    padding-right: 15px;
  }
`;

export const StyledLink = styled.a`
  margin-left: 15px;
  color: #337ab7;
  text-decoration: none;

  &:hover,
  &:focus {
    color: #23527c;
    text-decoration: underline;
  }
`;

export const StyledButton = styled(Button)`
  padding: 10px 20px;
  height: auto;
  background: #3b80e3;
  border-radius: 4px;
  margin-top: 20px;
`;

export const Heading = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin: 10px;
  margin-top: 25px;
  color: black;
`;
